<ng-container>
  <!-- photovoltaics tile value -->
  <app-feature-list-container>
    <div class="feature-grid-container photovoltaic-container" viFeatureGrid>
      <!-- photovoltaic.status -->
      <div>
        <!-- ess.photovoltaic.status -->
        <ng-container feature *ngIf="basicState; else photovoltaicOperationState">
          <app-feature-list-item
            feature
            [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.STATUS' | translate"
            [value]="basicState"
          ></app-feature-list-item>
        </ng-container>

        <ng-template #photovoltaicOperationState>
          <app-feature-list-item
            data-at-photovoltaic-status
            *ngIf="photovoltaicStatus$ | async | ready as feature"
            feature
            [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.STATUS' | translate"
            [value]="(feature | value2: featurePropertyKey.status | translatePhotovoltaicState) ?? NO_VALUE"
            [attr.data-feature]="feature.feature"
          ></app-feature-list-item>
        </ng-template>

        <!-- photovoltaic.production.current.consolidated for cascade device -->
        <app-feature-list-item
          data-at-photovoltaic-power
          *ngIf="
            (devicesStore.shouldUseConsolidatedFeature$ | async) &&
              (productionCurrentConsolidatedFeatures$ | async | ready) &&
              (productionCurrentConsolidatedPerDevice$ | async) as feature;
            else productionCurrent
          "
          feature
          [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.PRODUCTION' | translate"
          value="{{ feature | featureLike | value2: featurePropertyKey.value }} {{
            feature | featureLike | unit: featurePropertyKey.value
          }}"
        >
        </app-feature-list-item>

        <!-- photovoltaic.production.current for installation with one vitocharge -->
        <ng-template #productionCurrent>
          <app-feature-list-item
            data-at-photovoltaic-power
            *ngIf="productionCurrent$ | async | ready as feature"
            feature
            [error]="feature | error"
            [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.PRODUCTION' | translate"
            value="{{ feature | value2: featurePropertyKey.value }} {{
              feature | unit: featurePropertyKey.value
            }}"
            [attr.data-feature]="feature.feature"
          >
          </app-feature-list-item>
        </ng-template>

        <!-- photovoltaic.production.cumulated -->
        <app-feature-list-item
          data-at-photovoltaic-energy
          *ngIf="photovoltaicCumulatedEnergy$ | async | ready as feature"
          feature
          [error]="feature | error"
          [label]="
            '+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.PRODUCTION_COUNTER' | translate
          "
          value=" {{ (feature | value2: featurePropertyKey.lifeCycle) ?? NO_VALUE }} {{ (feature | unit: featurePropertyKey.lifeCycle) ?? ''  }} "
          [attr.data-feature]="feature.feature"
        >
        </app-feature-list-item>

        <!-- photovoltaic.insulationResistance.system -->
        <ng-container *ngIf="photovoltaicInsulationResistance$ | async | ready as feature">
          <app-feature-list-item
            data-at-photovoltaic-insulation-resistance-system
            *ngIf="
              (feature | value2: featurePropertyKey.status) ===
              photovoltaicInsulationResistanceStatus.valid
            "
            feature
            [error]="feature | error"
            [label]="
              '+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.INSULATION_RESISTANCE'
                | translate
            "
            value="{{ feature | value2: featurePropertyKey.value }} {{
              feature | unit: featurePropertyKey.value
            }}"
            [attr.data-feature]="feature.feature"
          >
          </app-feature-list-item>
        </ng-container>
      </div>

      <!-- photovoltaics string value -->
      <div
        *ngIf="
          (photovoltaicInstalledPeakPowerConsolidatedPerDevice$ | async | ready) ||
          (photovoltaicInstalledPeakPower$ | async | ready) ||
          isPhotovoltaicStringPresent
        "
      >
        <!-- photovoltaic.installedPeakPower.consolidated for cascade device -->
        <app-feature-list-item
          *ngIf="
            (devicesStore.shouldUseConsolidatedFeature$ | async) &&
              (photovoltaicInstalledPeakPowerConsolidatedFeatures$ | async | ready) &&
              (photovoltaicInstalledPeakPowerConsolidatedPerDevice$ | async) as feature;
            else photovoltaicInstalledPeakPower
          "
          class="string-value"
          [isNgContent]="true"
          data-at-photovoltaic-peak-power
        >
          <div class="flex w-full align-middle justify-between">
            <p>
              {{
                '+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.INSTALLED_PEAK_POWER'
                  | translate
              }}
            </p>
            <p>
              {{ feature | featureLike | value2: featurePropertyKey.value }}
              {{ feature | featureLike | unit: featurePropertyKey.value }}
            </p>
          </div>
        </app-feature-list-item>
        <!-- photovoltaic.installedPeakPower for single vitocharge device -->
        <ng-template #photovoltaicInstalledPeakPower>
          <app-feature-list-item
            *ngIf="photovoltaicInstalledPeakPower$ | async | ready as feature"
            class="string-value"
            [isNgContent]="true"
            data-at-photovoltaic-peak-power
            [attr.data-feature]="feature.feature"
          >
            <div class="flex w-full align-middle justify-between">
              <p>
                {{
                  '+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.INSTALLED_PEAK_POWER'
                    | translate
                }}
              </p>
              <p>
                {{ feature | value2: featurePropertyKey.value }}
                {{ feature | unit: featurePropertyKey.value }}
              </p>
            </div>
          </app-feature-list-item>
        </ng-template>
        <ng-container *ngFor="let pvString of photoVoltaicStrings">
          <app-feature-list-item
            class="string-value"
            [isNgContent]="true"
            *ngIf="isPhotovoltaicStringPresent"
          >
            <div class="w-full flex flex-col align-middle justify-between">
              <div class="flex align-middle justify-between">
                <p>
                  {{ '+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.STRING' | translate }}
                  {{ pvString.pvStringIdLetter }}
                </p>
                <p>
                  {{ pvString.voltageFeature | value2: featurePropertyKey.value }}
                  {{ pvString.voltageFeature | unit: featurePropertyKey.value }}
                </p>
              </div>
              <div class="flex align-middle justify-between">
                <p>
                  {{ pvString.electricityFeature | value2: featurePropertyKey.value }}
                  {{ pvString.electricityFeature | unit: featurePropertyKey.value }}
                </p>
                <p>
                  {{ pvString.powerFeature | value2: featurePropertyKey.value }}
                  {{ pvString.powerFeature | unit: featurePropertyKey.value }}
                </p>
              </div>
            </div>
          </app-feature-list-item>
        </ng-container>
      </div>
    </div>
  </app-feature-list-container>
</ng-container>
